/* tslint:disable */

declare var Object: any;
export interface StorageAttendanceLocalInterface {
  "id"?: number;
}

export class StorageAttendanceLocal implements StorageAttendanceLocalInterface {
  "id": number;
  constructor(data?: StorageAttendanceLocalInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StorageAttendanceLocal`.
   */
  public static getModelName() {
    return "StorageAttendanceLocal";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StorageAttendanceLocal for dynamic purposes.
  **/
  public static factory(data: StorageAttendanceLocalInterface): StorageAttendanceLocal{
    return new StorageAttendanceLocal(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StorageAttendanceLocal',
      plural: 'StorageAttendanceLocals',
      path: 'StorageAttendanceLocals',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/StorageAttendanceLocal.ts